// Chain lookup shared by every Forge dashboard.
import { ForgeSupportedChainsResponse } from '../../types/dashboardShared';
import { forgeRequest } from '../forgeRequest';
import { FORGE_ADMIN_API_URL } from './endpoints';

export async function fetchSupportedChains(token: string): Promise<ForgeSupportedChainsResponse> {
  return forgeRequest<ForgeSupportedChainsResponse>(
    token,
    `${FORGE_ADMIN_API_URL}/supported-chains`,
    'Error fetching supported Forge chains'
  );
}
